import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getAccounts: async ({ commit }, payload) => {
    try {
      const { ...params } = payload;
      const res = await axios.get(`/accounts`, {
        params: { ...params }
      });

      commit('mutateAccounts', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getAccountById: async ({ commit }, payload) => {
    try {
      const { accountId, ...params } = payload;

      const res = await axios.get(`/accounts/${accountId}`, {
        params: { ...params }
      });

      commit('mutateAccountById', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateAccount: async (_, payload) => {
    try {
      const { accountId, ...body } = payload;
      const res = await axios.put(
        `/accounts/${accountId}`,
        body
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  startPasswordReset: async (_, body) => {
    try {
      const res = await axios.post(
        `/accounts/reset/password`,
        body
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getAccountByToken: async ({ commit }, payload) => {
    try {
      const { token } = payload;
      const res = await axios.get(
        `/accounts/reset/password/${token}`
      );
      commit('mutateAccountByToken', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  completePasswordReset: async (_, payload) => {
    try {
      const { token, ...body } = payload;
      const res = await axios.post(
        `/accounts/reset/password/${token}`,
        body
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  createAccount: async (_, payload) => {
    try {
      const res = await axios.post(
        `/accounts/signup/create-account`,
        payload
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getNewAccountInformation: async ({ commit }, payload) => {
    try {
      const { token } = payload;
      const res = await axios.get(
        `/accounts/signup/${token}`
      );
      commit('mutateNewAccountInformation', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  confirmRegistration: async (_, payload) => {
    const { token, language, ...theRest } = payload;
    try {
      const res = await axios.post(
        `/accounts/signup/confirm-registration/${language}/${token}`,
        theRest
      );
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  mutateAccounts: (state, payload) => {
    state.accounts = payload;
  },

  mutateAccountById: (state, payload) => {
    state.accountById = payload;
  },

  mutateAccountByToken: (state, payload) => {
    state.accountByToken = payload;
  },

  mutateNewAccountInformation: (state, payload) => {
    state.newAccountInformation = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    accounts: [],
    accountById: {},
    accountByToken: {},
    newAccountInformation: {}
  };
}
